import React from "react";

import * as S from "./AIAdvisorTableHeader.style";

const AIAdvisorTableHeader = () => {
  return (
    <S.TableHeader>
      <S.TableHeaderCell $maxWidth="8rem">
        <S.TableHeaderValue>Drug Index</S.TableHeaderValue>
      </S.TableHeaderCell>
      <S.TableHeaderCell $maxWidth="14.4rem">
        <S.TableHeaderValue>Key</S.TableHeaderValue>
      </S.TableHeaderCell>
      <S.TableHeaderCell $maxWidth="28rem">
        <S.TableHeaderValue>Changed Value</S.TableHeaderValue>
      </S.TableHeaderCell>
      <S.TableHeaderCell $minWidth="40rem">
        <S.TableHeaderValue>Reason</S.TableHeaderValue>
      </S.TableHeaderCell>
      <S.TableHeaderCell $minWidth="40rem">
        <S.TableHeaderValue>Source Evidence</S.TableHeaderValue>
      </S.TableHeaderCell>
    </S.TableHeader>
  );
};

export default AIAdvisorTableHeader;
